import { useEffect, useRef, useState } from "react";
import {ExcelBtn,formBtn1,formBtn2, formBtn3, inputClass,labelClass,pageClass,pageHeader,pdfBtn} from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import DeleteEmployeeModal from "../Components/Modals/DeleteEmployeeModal";
import ViewEmployeeModal from "../Components/Modals/ViewEmployeeModal";
import AddEmploye from "../Components/Modals/AddEmploye";
import { AssignUserAPI, GetAllCompanyAPI } from "../API/Api";
import { useSelector } from "react-redux";
import Select from "react-select"; 
import { Controller, useForm } from "react-hook-form";
import usePaginatedData from "../Components/Utils/UsePagination";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import {customStyles, downloadCSV,downloadTablePDF, onMenuClose, onMenuOpen} from "../Components/Utils/CommonFuntion";
import Switch from "react-switch";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { UpdateAdminUserAPI } from "../API/Api";
import { IconEye } from "@tabler/icons-react";

export default function Employees() {
  const {register,handleSubmit,control,watch,reset,formState: { errors },setValue} = useForm({defaultValues: {
    user: null,
    company: "",
    roleId: "",
    search: ""
  }});
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const RoleDetails = useSelector((state) => state?.login?.roleDetails);
  const [EmployeeModal, setEmployeeModal] = useState(false);
  const [RowsData, setRowsData] = useState([]);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);  
  const [Company, setCompany] = useState([]);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const themeColor = useThemeColor();
  const company = watch("company");
  const search = watch("search");
  const roleId = watch("roleId");
  const user = watch("user");
  const initialFilterState = {
    p: 1,
    company:
      UserDetails?.role?.roleName !== "SuperAdmin"
        ? UserDetails?.company?._id
        : "",
    search: "",
    id: UserDetails?._id || "", // Adding user ID
    role: UserDetails?.role?.roleName || "", // Adding role name
  };

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });

  const {
    filterData: tableData,
    pageNo,
    records,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    nextIsValid,
    prevIsValid,
    loader
  } = usePaginatedData(1, 50, AssignUserAPI, filterObject);

  const assignToOptions =
    tableData != undefined
      ? tableData.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
        }))
      : [{ value: "", label: "No user found" }];
  
  useEffect(() => {
    setIsApplyDisabled(!(company || search || roleId || user));
  }, [company, search, roleId, user]);

  const HandleViewEmployee = (row) => {
    setRowsData(row);
    setEmployeeModal(true);
  };

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
    await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const getallCompany = async () => {
    try {
      const parentCompanyId = UserDetails?.role?.roleName === "SuperAdmin" ? UserDetails?.company?._id : "";
      const res = await GetAllCompanyAPI(parentCompanyId);
      setCompany(res?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const handleUserDelistToggle = (checked, rowData) => {
    Swal.fire({
      title: "Warning",
      text: `Do you really want to ${checked ? "list" : "delist"} this Employee?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        confirmButton: `${formBtn1}`,
        cancelButton: `${formBtn3}`
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await UpdateAdminUserAPI(rowData?._id, { isUserListed: checked });
          if (response?.status == 201) {
            toast.success(response?.data?.message);
            filterRecords();
          } else {
            toast.error(response?.error)
          }
        } catch (err) {
          console.log("Error:", err);
        }
      }
    });
  };

  const tableColumns = [
    {
      field: "name",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const firstName = row?.first_name || "";
        const lastName = row?.last_name || "";
        const fullName = (firstName && lastName) ? `${firstName} ${lastName}` : firstName || lastName || "-----";
        return <h6>{fullName}</h6>;
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => <h6>{row?.email}</h6>,
    },
    {
      field: "phone_number",
      header: "Phone Number",
      style: true,
      body: (row) => <h6>{row?.phone_number}</h6>,
    },
    {
      field: "role",
      header: "Role",
      style: true,
      body: (row) => <h6>{row?.role?.roleName}</h6>,
    },
    {
      field: "assign_to",
      header: "Assign To",
      style: true,
      body: (row) => (
        <h6>{`${row?.assign_to?.first_name} ${row?.assign_to?.last_name}`}</h6>
      ),
    },
    UserDetails?.role?.roleName === "SuperAdmin" && {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName}</h6>,
    },
    {
      field: "isUserListed",
      header: "Active / Inactive",
      body: (row) => (
        <Switch
          checked={row?.isUserListed}
          onChange={(checked) => handleUserDelistToggle(checked, row)}
          checkedIcon={false}
          uncheckedIcon={false}
          offColor="#ccc"
          onColor="#4CAF50"
        />
      )
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleViewEmployee(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
            <IconEye stroke={1.5} size={24} color="#000" />
          </button>
          <AddEmploye
            edit={true}
            rowdata={row}
            filterRecords={filterRecords}
            Company={Company}
          />
          {(UserDetails?.role?.roleName == "SuperAdmin" ||
            UserDetails?.role?.roleName == "Admin") && (
            <>
              <DeleteEmployeeModal row={row} filterRecords={filterRecords} />
            </>
          )}
        </div>
      ),
    },
  ].filter(Boolean);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    getallCompany();
  }, []);

  const submitPdfExcel = async (download) => {
    const params = {
    ...filterObject,
    p: 1,
    records: 100000, // set a high limit to get all records
  };
  const res = await AssignUserAPI(params);
  const Data = (res?.data?.filteredData).filter(
    (emp) => emp?._id !== UserDetails?._id
  );
  
    const Header = [
      "name",
      "email",
      "phone_number",
      "role",
      "assign_to",
    ];
    const formattedEmployeeData = Data?.map((Employee) => ({
      ...Employee,
      name: (Employee?.first_name && Employee?.last_name) 
    ? `${Employee?.first_name} ${Employee?.last_name}`
    : Employee?.first_name || Employee?.last_name || "",
      assign_to: `${Employee?.assign_to?.first_name || ""} ${
        Employee?.assign_to?.last_name || ""
      }`.trim(),
      role: `${Employee?.role?.roleName || ""}`.trim(),
    }));
    download === "Csv"
      ? downloadCSV(Header, formattedEmployeeData, "Employee")
      : downloadTablePDF(Header, formattedEmployeeData, "Employee");
  };

  // Function to handle filter submission
  const filterSubmit = (data) => {
    const payload = {
      ...filterObject,
      company: data.company ? data.company : "",
      search: data.search ? data.search : "",
      roleId:  data.roleId ? data?.roleId : "",
      user: data?.user?.value ? data?.user?.value : ""
    }
    setFilterObject(payload);
  };

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between flex-col sm:flex-row">
            <h1 className={`${pageHeader} sm:mb-0`}>Employees</h1>
            {UserDetails?.role?.roleName == "SuperAdmin" ||
            UserDetails?.role?.roleName == "Admin" ? (
              <div className="flex flex-wrap sm:flex-nowrap gap-2">
                <div className="flex items-center">
                  <button
                    className={ExcelBtn}
                    onClick={() => submitPdfExcel("Csv")}
                  >
                    Excel
                  </button>
                  <button
                    className={pdfBtn}
                    onClick={() => submitPdfExcel("Pdf")}
                  >
                    PDF
                  </button>
                </div>
                <AddEmploye
                  Company={Company}
                  edit={false}
                  filterRecords={filterRecords}
                />
              </div>
            ) : null}
          </div>
          <div className="bg-white rounded-xl mt-4">
            <form
              onSubmit={handleSubmit(filterSubmit)}
              className="flex flex-col lg:flex-row gap-3"
            >
              {/* FILTERS DIV */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {UserDetails?.role?.roleName == "SuperAdmin" && (
                  <div>
                    <select
                      name="company_id"
                      className={`${inputClass} !bg-slate-100 ${
                        company == "" ? "text-slate-400" : ""
                      }`}
                      {...register("company")}
                    >
                      <option value="">Company Name</option>

                      {Company?.map((company) => (
                        <option key={company?._id} value={company?._id}>
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <input
                    type="text"
                    placeholder="Enter Full Name"
                    className={inputClass}
                    {...register("search")}
                  />
                </div>
                <div>
                  <select className={inputClass} {...register("roleId")}>
                    <option value="">Select Role</option>
                    {RoleDetails?.filter(
                      (role) => role?.roleName !== "Admin",
                    ).map((role) => (
                      <option key={role?._id} value={role?._id}>
                        {role?.roleName}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <Controller
                    name="user"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={customStyles}
                        options={assignToOptions}
                        placeholder="Select User"
                        isClearable
                        maxMenuHeight={220}
                        onMenuOpen={onMenuOpen}
                        onMenuClose={onMenuClose}
                      />
                    )}
                  />
                </div>
              </div>
              {/* BUTTON DIV */}
              <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                <button
                  type="submit"
                  className={`${formBtn1} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : "bg-base-color"
                  }`}
                  disabled={isApplyDisabled}
                >
                  Apply
                </button>

                <button
                  type="button"
                  onClick={() => {
                    reset();
                    setFilterObject(initialFilterState);
                  }}
                  className={`${formBtn2} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={isApplyDisabled}
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={tableData?.filter(
                (user) => user?.role?.roleName !== "Admin",
              )}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              records={records}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
          <ViewEmployeeModal
            EmployeeModal={EmployeeModal}
            setEmployeeModal={setEmployeeModal}
            row={RowsData}
          />
        </div>
      </div>
    </>
  );
}
